"use client";

import React from "react";

const PreventiveMeasures: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        Fluoride Treatment: A Comprehensive Look at Preventive Measures
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        While fluoride treatments play a crucial role in preventing tooth decay, they&rsquo;re just one piece of the puzzle when it comes to maintaining optimal oral health. Regular brushing and flossing are essential for removing plaque and food debris that can lead to cavities if left untreated.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        But what about other preventive measures? Your dentist may recommend additional treatments or lifestyle changes to help protect your teeth from decay. For example, they might suggest using a fluoride mouthwash at home, or applying dental sealants to the chewing surfaces of your back teeth to prevent bacteria from accumulating in hard-to-reach grooves and fissures.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Regular dental check-ups are also vital for maintaining good oral health. During these appointments, your dentist can detect any signs of decay or other issues early on, when they&#39;re easiest to treat. They can also provide personalized advice and recommendations tailored to your unique oral health needs.
      </p>
    </div>
  );
};

export default PreventiveMeasures;